// CATALOGUE — model specifications.
//
// Source: Daikin RA Master Catalogue 2026. Prices are NOT here — they live in
// pricing.js. Never edit this file to change a price.
//
// DAIKIN MAKES NO WINDOW ACs. No window type exists here and none must be
// added. Daikin-only section; no other brand appears on it.
//
// KIT VARIANTS. G-prefix ships WITHOUT the piping kit, F and J prefix ship
// WITH it. Not every model has both: FTHT, JTKJ and FTKL90 are with-kit only,
// so those product pages show no kit choice at all.
//
// `kw` is the real capacity. `soldAs` is a marketing label and must never
// drive a decision: a unit sold as 1.5 ton is 5.0 kW, which is 1.42 TR, while
// JTKJ53 at 5.28 kW is a true 1.50 TR.
//
// IMAGES. Each model has a folder at public/products/{imageCode}/ holding
// seven files named {imageBase}-{slot}.webp, where slot is one of:
// front, features, warranty, filters, energy-label, remote, outdoor-unit.
//
// imageCode is the F or J indoor model code in lowercase. G and F variants are
// the same physical unit and share one folder, so there are 18 folders, not 29.
//
// `image` is slot 1 (front) and is what the grid card, the cart and the
// Product schema use. Any missing file falls back to a placeholder or is
// dropped from the gallery, so the page never looks broken mid-upload.

export const CATALOGUE = [
  {
    "id": "gtq-28",
    "series": "GTQ",
    "label": "GTQ Standard",
    "blurb": "Fixed speed. Lowest entry price, best for light or occasional use.",
    "kw": 2.8,
    "tr": 0.8,
    "soldAs": "0.8",
    "stars": 2,
    "iseer": 3.9,
    "annualKwh": 555.81,
    "inverter": false,
    "features": [
      "Smell proof operation",
      "Econo mode",
      "Dry mode",
      "Inner grooved pipe"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTQ28XV16WBA",
        "odu": "RQG28XV16WBA",
        "mrp": 34400
      },
      "withKit": {
        "idu": "FTQ28XV16WBA",
        "odu": "RQ28XV16WBA",
        "mrp": 36000
      }
    },
    "title": "Daikin 0.8 Ton 2 Star Fixed Speed Split AC",
    "slug": "daikin-0-8-ton-2-star-fixed-speed-split-ac-gtq28xv16wba",
    "image": "/products/ftq28xv16wba/daikin-ftq28xv16wba-0-8-ton-2-star-fixed-speed-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftq28xv16wba",
    "imageBase": "daikin-ftq28xv16wba-0-8-ton-2-star-fixed-speed-split-ac"
  },
  {
    "id": "gtq-35",
    "series": "GTQ",
    "label": "GTQ Standard",
    "blurb": "Fixed speed. Lowest entry price, best for light or occasional use.",
    "kw": 3.35,
    "tr": 0.95,
    "soldAs": "1.0",
    "stars": 2,
    "iseer": 3.9,
    "annualKwh": 664.96,
    "inverter": false,
    "features": [
      "Smell proof operation",
      "Econo mode",
      "Dry mode",
      "Inner grooved pipe"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTQ35XV16WBA",
        "odu": "RQG35XV16WBA",
        "mrp": 43700
      },
      "withKit": {
        "idu": "FTQ35XV16WBA",
        "odu": "RQ35XV16WBA",
        "mrp": 45400
      }
    },
    "title": "Daikin 1.0 Ton 2 Star Fixed Speed Split AC",
    "slug": "daikin-1-0-ton-2-star-fixed-speed-split-ac-gtq35xv16wba",
    "image": "/products/ftq35xv16wba/daikin-ftq35xv16wba-1-0-ton-2-star-fixed-speed-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftq35xv16wba",
    "imageBase": "daikin-ftq35xv16wba-1-0-ton-2-star-fixed-speed-split-ac"
  },
  {
    "id": "gtq-50",
    "series": "GTQ",
    "label": "GTQ Standard",
    "blurb": "Fixed speed. Lowest entry price, best for light or occasional use.",
    "kw": 5.05,
    "tr": 1.44,
    "soldAs": "1.5",
    "stars": 2,
    "iseer": 3.9,
    "annualKwh": 1002.47,
    "inverter": false,
    "features": [
      "Smell proof operation",
      "Econo mode",
      "Dry mode",
      "Inner grooved pipe"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTQ50XV16UCA",
        "odu": "RQG50XV16UCA",
        "mrp": 54200
      },
      "withKit": {
        "idu": "FTQ50XV16UCA",
        "odu": "RQ50XV16UCA",
        "mrp": 55900
      }
    },
    "title": "Daikin 1.5 Ton 2 Star Fixed Speed Split AC",
    "slug": "daikin-1-5-ton-2-star-fixed-speed-split-ac-gtq50xv16uca",
    "image": "/products/ftq50xv16uca/daikin-ftq50xv16uca-1-5-ton-2-star-fixed-speed-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftq50xv16uca",
    "imageBase": "daikin-ftq50xv16uca-1-5-ton-2-star-fixed-speed-split-ac"
  },
  {
    "id": "gtkc-35",
    "series": "GTKC",
    "label": "GTKC Standard",
    "blurb": "Inverter at the value end. No special filtration.",
    "kw": 3.52,
    "tr": 1,
    "soldAs": "1.0",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 619.31,
    "inverter": true,
    "features": [
      "Swing compressor",
      "Triple display",
      "Dew Clean",
      "Stabiliser inside"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKC35XV16WAA",
        "odu": "RKCG35XV16WAA",
        "mrp": 46000
      },
      "withKit": {
        "idu": "FTKC35XV16WAA",
        "odu": "RKC35XV16WAA",
        "mrp": 47800
      }
    },
    "title": "Daikin 1.0 Ton 3 Star Inverter Split AC",
    "slug": "daikin-1-0-ton-3-star-inverter-split-ac-gtkc35xv16waa",
    "image": "/products/ftkc35xv16waa/daikin-ftkc35xv16waa-1-0-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkc35xv16waa",
    "imageBase": "daikin-ftkc35xv16waa-1-0-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkc-50",
    "series": "GTKC",
    "label": "GTKC Standard",
    "blurb": "Inverter at the value end. No special filtration.",
    "kw": 5,
    "tr": 1.42,
    "soldAs": "1.5",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 880.1,
    "inverter": true,
    "features": [
      "Swing compressor",
      "Triple display",
      "Dew Clean",
      "Stabiliser inside"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKC50XV16VKA",
        "odu": "RKCG50XV16VKA",
        "mrp": 52800
      },
      "withKit": {
        "idu": "FTKC50XV16VKA",
        "odu": "RKC50XV16VKA",
        "mrp": 54400
      }
    },
    "title": "Daikin 1.5 Ton 3 Star Inverter Split AC",
    "slug": "daikin-1-5-ton-3-star-inverter-split-ac-gtkc50xv16vka",
    "image": "/products/ftkc50xv16vka/daikin-ftkc50xv16vka-1-5-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkc50xv16vka",
    "imageBase": "daikin-ftkc50xv16vka-1-5-ton-3-star-inverter-split-ac"
  },
    {
    "id": "gtkl-35",
    "series": "GTKL",
    "label": "GTKL Premium",
    "blurb": "Premium build with PM2.5 and active carbon filtration.",
    "kw": 3.52,
    "tr": 1,
    "soldAs": "1.0",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 619.31,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "3D airflow",
      "Power Chill"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKL35XV16WAA",
        "odu": "RKLG35XV16WAA",
        "mrp": 46700
      }
    },
    "title": "Daikin 1.0 Ton 3 Star Inverter Split AC",
    "slug": "daikin-1-0-ton-3-star-inverter-split-ac-gtkl35xv16waa",
    "image": "/products/ftkl35xv16waa/daikin-ftkl35xv16waa-1-0-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkl35xv16waa",
    "imageBase": "daikin-ftkl35xv16waa-1-0-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkl-50",
    "series": "GTKL",
    "label": "GTKL Premium",
    "blurb": "Premium build with PM2.5 and active carbon filtration.",
    "kw": 5,
    "tr": 1.42,
    "soldAs": "1.5",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 880.1,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "3D airflow",
      "Power Chill"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKL50XV16VAA",
        "odu": "RKLG50XV16VAA",
        "mrp": 54500
      },
      "withKit": {
        "idu": "FTKL50XV16VAA",
        "odu": "RKL50XV16VAA",
        "mrp": 56100
      }
    },
    "title": "Daikin 1.5 Ton 3 Star Inverter Split AC",
    "slug": "daikin-1-5-ton-3-star-inverter-split-ac-gtkl50xv16vaa",
    "image": "/products/ftkl50xv16vaa/daikin-ftkl50xv16vaa-1-5-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkl50xv16vaa",
    "imageBase": "daikin-ftkl50xv16vaa-1-5-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkl-60",
    "series": "GTKL",
    "label": "GTKL Premium",
    "blurb": "Premium build with PM2.5 and active carbon filtration.",
    "kw": 6,
    "tr": 1.71,
    "soldAs": "1.8",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 1055.07,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "3D airflow",
      "Power Chill"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKL60XV16VAA",
        "odu": "RKLG60XV16VAA",
        "mrp": 66900
      },
      "withKit": {
        "idu": "FTKL60XV16VAA",
        "odu": "RKL60XV16VAA",
        "mrp": 68700
      }
    },
    "title": "Daikin 1.8 Ton 3 Star Inverter Split AC",
    "slug": "daikin-1-8-ton-3-star-inverter-split-ac-gtkl60xv16vaa",
    "image": "/products/ftkl60xv16vaa/daikin-ftkl60xv16vaa-1-8-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkl60xv16vaa",
    "imageBase": "daikin-ftkl60xv16vaa-1-8-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkl-71",
    "series": "GTKL",
    "label": "GTKL Premium",
    "blurb": "Premium build with PM2.5 and active carbon filtration.",
    "kw": 7.03,
    "tr": 2,
    "soldAs": "2.0",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 1238.03,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "3D airflow",
      "Power Chill"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKL71XV16MAA",
        "odu": "RKLG71XV16MAA",
        "mrp": 80900
      },
      "withKit": {
        "idu": "FTKL71XV16MAA",
        "odu": "RKL71XV16MAA",
        "mrp": 82500
      }
    },
    "title": "Daikin 2.0 Ton 3 Star Inverter Split AC",
    "slug": "daikin-2-0-ton-3-star-inverter-split-ac-gtkl71xv16maa",
    "image": "/products/ftkl71xv16maa/daikin-ftkl71xv16maa-2-0-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkl71xv16maa",
    "imageBase": "daikin-ftkl71xv16maa-2-0-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkl-90",
    "series": "GTKL",
    "label": "GTKL Premium",
    "blurb": "Premium build with PM2.5 and active carbon filtration.",
    "kw": 9.15,
    "tr": 2.6,
    "soldAs": "2.5",
    "stars": 3,
    "iseer": 4.8,
    "annualKwh": 1476.47,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "3D airflow",
      "Power Chill"
    ],
    "variants": {
      "withKit": {
        "idu": "FTKL90XV16LAA",
        "odu": "RKL90XV16LAA",
        "mrp": 121000
      }
    },
    "title": "Daikin 2.5 Ton 3 Star Inverter Split AC",
    "slug": "daikin-2-5-ton-3-star-inverter-split-ac-ftkl90xv16laa",
    "image": "/products/ftkl90xv16laa/daikin-ftkl90xv16laa-2-5-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkl90xv16laa",
    "imageBase": "daikin-ftkl90xv16laa-2-5-ton-3-star-inverter-split-ac"
  },
  {
    "id": "gtkm-35",
    "series": "GTKM",
    "label": "GTKM Premium",
    "blurb": "Five star. Lowest running cost in the range and rated to 55C.",
    "kw": 3.5,
    "tr": 1,
    "soldAs": "1.0",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 475.37,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "Cools to 55C",
      "Triple display"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKM35XV16VAA",
        "odu": "RKMG35XV16VAA",
        "mrp": 54100
      },
      "withKit": {
        "idu": "FTKM35XV16VAA",
        "odu": "RKM35XV16VAA",
        "mrp": 55900
      }
    },
    "title": "Daikin 1.0 Ton 5 Star Inverter Split AC",
    "slug": "daikin-1-0-ton-5-star-inverter-split-ac-gtkm35xv16vaa",
    "image": "/products/ftkm35xv16vaa/daikin-ftkm35xv16vaa-1-0-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkm35xv16vaa",
    "imageBase": "daikin-ftkm35xv16vaa-1-0-ton-5-star-inverter-split-ac"
  },
  {
    "id": "gtkm-50",
    "series": "GTKM",
    "label": "GTKM Premium",
    "blurb": "Five star. Lowest running cost in the range and rated to 55C.",
    "kw": 5,
    "tr": 1.42,
    "soldAs": "1.5",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 678.92,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "Cools to 55C",
      "Triple display"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKM50XV16MKA",
        "odu": "RKMG50XV16MKA",
        "mrp": 66500
      },
      "withKit": {
        "idu": "FTKM50XV16MKA",
        "odu": "RKM50XV16MKA",
        "mrp": 68200
      }
    },
    "title": "Daikin 1.5 Ton 5 Star Inverter Split AC",
    "slug": "daikin-1-5-ton-5-star-inverter-split-ac-gtkm50xv16mka",
    "image": "/products/ftkm50xv16mka/daikin-ftkm50xv16mka-1-5-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkm50xv16mka",
    "imageBase": "daikin-ftkm50xv16mka-1-5-ton-5-star-inverter-split-ac"
  },
    {
    "id": "ftku-50",
    "series": "FTKU",
    "label": "FTKU Standard",
    "blurb": "Five star efficiency at a lower price. PM2.5 filter and Dew Clean.",
    "kw": 5,
    "tr": 1.42,
    "soldAs": "1.5",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 678.92,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Dew Clean",
      "Triple display",
      "Power Chill"
    ],
    "variants": {
      "withKit": {
        "idu": "FTKU50XV16MKA",
        "odu": "RKU50XV16MKA",
        "mrp": 68500
      }
    },
    "title": "Daikin 1.5 Ton 5 Star Standard Inverter Split AC",
    "slug": "daikin-1-5-ton-5-star-inverter-split-ac-ftku50xv16mka",
    "image": "/products/ftku50xv16mka/daikin-ftku50xv16mka-1-5-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftku50xv16mka",
    "imageBase": "daikin-ftku50xv16mka-1-5-ton-5-star-inverter-split-ac"
  },
  {
    "id": "gtkm-60",
    "series": "GTKM",
    "label": "GTKM Premium",
    "blurb": "Five star. Lowest running cost in the range and rated to 55C.",
    "kw": 6,
    "tr": 1.71,
    "soldAs": "1.8",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 814.17,
    "inverter": true,
    "features": [
      "PM2.5 filter",
      "Active carbon filter",
      "Cools to 55C",
      "Triple display"
    ],
    "variants": {
      "withoutKit": {
        "idu": "GTKM60XV16MAA",
        "odu": "RKMG60XV16MAA",
        "mrp": 89400
      },
      "withKit": {
        "idu": "FTKM60XV16MAA",
        "odu": "RKM60XV16MAA",
        "mrp": 91300
      }
    },
    "title": "Daikin 1.8 Ton 5 Star Inverter Split AC",
    "slug": "daikin-1-8-ton-5-star-inverter-split-ac-gtkm60xv16maa",
    "image": "/products/ftkm60xv16maa/daikin-ftkm60xv16maa-1-8-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftkm60xv16maa",
    "imageBase": "daikin-ftkm60xv16maa-1-8-ton-5-star-inverter-split-ac"
  },
  {
    "id": "ftht-35",
    "series": "FTHT",
    "label": "FTHT Hot and Cold",
    "blurb": "Heats as well as cools. Works through a Delhi winter.",
    "kw": 3.52,
    "tr": 1,
    "soldAs": "1.0",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 619.02,
    "inverter": true,
    "features": [
      "Heating -10C to 24C",
      "PM1.0 filter",
      "CO2 filter",
      "Power Full"
    ],
    "variants": {
      "withKit": {
        "idu": "FTHT35XV16WAA",
        "odu": "RHT35XV16WAA",
        "mrp": 51500
      }
    },
    "title": "Daikin 1.0 Ton 3 Star Inverter Hot & Cold Split AC",
    "slug": "daikin-1-0-ton-3-star-inverter-hot-and-cold-split-ac-ftht35xv16waa",
    "image": "/products/ftht35xv16waa/daikin-ftht35xv16waa-1-0-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftht35xv16waa",
    "imageBase": "daikin-ftht35xv16waa-1-0-ton-3-star-inverter-split-ac"
  },
  {
    "id": "ftht-50",
    "series": "FTHT",
    "label": "FTHT Hot and Cold",
    "blurb": "Heats as well as cools. Works through a Delhi winter.",
    "kw": 5,
    "tr": 1.42,
    "soldAs": "1.5",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 880.1,
    "inverter": true,
    "features": [
      "Heating -10C to 24C",
      "PM1.0 filter",
      "CO2 filter",
      "Power Full"
    ],
    "variants": {
      "withKit": {
        "idu": "FTHT50XV16VAA",
        "odu": "RHT50XV16VAA",
        "mrp": 61600
      }
    },
    "title": "Daikin 1.5 Ton 3 Star Inverter Hot & Cold Split AC",
    "slug": "daikin-1-5-ton-3-star-inverter-hot-and-cold-split-ac-ftht50xv16vaa",
    "image": "/products/ftht50xv16vaa/daikin-ftht50xv16vaa-1-5-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftht50xv16vaa",
    "imageBase": "daikin-ftht50xv16vaa-1-5-ton-3-star-inverter-split-ac"
  },
  {
    "id": "ftht-60",
    "series": "FTHT",
    "label": "FTHT Hot and Cold",
    "blurb": "Heats as well as cools. Works through a Delhi winter.",
    "kw": 6,
    "tr": 1.71,
    "soldAs": "1.8",
    "stars": 3,
    "iseer": 4.4,
    "annualKwh": 1055.07,
    "inverter": true,
    "features": [
      "Heating -10C to 24C",
      "PM1.0 filter",
      "CO2 filter",
      "Power Full"
    ],
    "variants": {
      "withKit": {
        "idu": "FTHT60XV16UAA",
        "odu": "RHT60XV16UAA",
        "mrp": 72200
      }
    },
    "title": "Daikin 1.8 Ton 3 Star Inverter Hot & Cold Split AC",
    "slug": "daikin-1-8-ton-3-star-inverter-hot-and-cold-split-ac-ftht60xv16uaa",
    "image": "/products/ftht60xv16uaa/daikin-ftht60xv16uaa-1-8-ton-3-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "ftht60xv16uaa",
    "imageBase": "daikin-ftht60xv16uaa-1-8-ton-3-star-inverter-split-ac"
  },
  {
    "id": "jtkj-35",
    "series": "JTKJ",
    "label": "JTKJ Waizu",
    "blurb": "Top of the range. WiFi, voice control and Streamer purification.",
    "kw": 3.5,
    "tr": 1,
    "soldAs": "1.0",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 475.37,
    "inverter": true,
    "features": [
      "Patented Streamer",
      "WiFi and voice control",
      "Intelligent Eye",
      "PM1.0 filter"
    ],
    "variants": {
      "withKit": {
        "idu": "JTKJ35XV16VAA",
        "odu": "RKJ35XV16VAA",
        "mrp": 62400
      }
    },
    "title": "Daikin 1.0 Ton 5 Star Inverter WiFi Split AC",
    "slug": "daikin-1-0-ton-5-star-inverter-wifi-split-ac-jtkj35xv16vaa",
    "image": "/products/jtkj35xv16vaa/daikin-jtkj35xv16vaa-1-0-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "jtkj35xv16vaa",
    "imageBase": "daikin-jtkj35xv16vaa-1-0-ton-5-star-inverter-split-ac"
  },
  {
    "id": "jtkj-53",
    "series": "JTKJ",
    "label": "JTKJ Waizu",
    "blurb": "Top of the range. WiFi, voice control and Streamer purification.",
    "kw": 5.28,
    "tr": 1.5,
    "soldAs": "1.5",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 716.97,
    "inverter": true,
    "features": [
      "Patented Streamer",
      "WiFi and voice control",
      "Intelligent Eye",
      "PM1.0 filter"
    ],
    "variants": {
      "withKit": {
        "idu": "JTKJ53XV16MAA",
        "odu": "RKJ53XV16MAA",
        "mrp": 77200
      }
    },
    "title": "Daikin 1.5 Ton 5 Star Inverter WiFi Split AC",
    "slug": "daikin-1-5-ton-5-star-inverter-wifi-split-ac-jtkj53xv16maa",
    "image": "/products/jtkj53xv16maa/daikin-jtkj53xv16maa-1-5-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "jtkj53xv16maa",
    "imageBase": "daikin-jtkj53xv16maa-1-5-ton-5-star-inverter-split-ac"
  },
  {
    "id": "jtkj-60",
    "series": "JTKJ",
    "label": "JTKJ Waizu",
    "blurb": "Top of the range. WiFi, voice control and Streamer purification.",
    "kw": 6,
    "tr": 1.71,
    "soldAs": "1.8",
    "stars": 5,
    "iseer": 5.7,
    "annualKwh": 814.17,
    "inverter": true,
    "features": [
      "Patented Streamer",
      "WiFi and voice control",
      "Intelligent Eye",
      "PM1.0 filter"
    ],
    "variants": {
      "withKit": {
        "idu": "JTKJ60XV16MAA",
        "odu": "RKJ60XV16MAA",
        "mrp": 96300
      }
    },
    "title": "Daikin 1.8 Ton 5 Star Inverter WiFi Split AC",
    "slug": "daikin-1-8-ton-5-star-inverter-wifi-split-ac-jtkj60xv16maa",
    "image": "/products/jtkj60xv16maa/daikin-jtkj60xv16maa-1-8-ton-5-star-inverter-split-ac-front.webp",
    "coverageSqft": null,
    "noiseDb": null,
    "airflowCfm": null,
    "compressor": null,
    "dimsIdu": null,
    "dimsOdu": null,
    "ambientMax": null,
    "imageCode": "jtkj60xv16maa",
    "imageBase": "daikin-jtkj60xv16maa-1-8-ton-5-star-inverter-split-ac"
  }
];

export const findModel = (id) => CATALOGUE.find((m) => m.id === id) || null;
export const findBySlug = (slug) => CATALOGUE.find((m) => m.slug === slug) || null;

// Sibling models for the variant switcher at the top of a product page.
// Same series, different capacity — and same capacity, different star rating.
// This is both a UX shortcut and the internal linking that spreads authority
// across the product pages.
export function siblingsByCapacity(model) {
  return CATALOGUE
    .filter((m) => m.series === model.series)
    .sort((a, b) => a.kw - b.kw);
}

export function siblingsByRating(model) {
  return CATALOGUE
    .filter((m) => m.soldAs === model.soldAs && m.id !== model.id)
    .sort((a, b) => a.stars - b.stars);
}

export const tonnageOptions = () =>
  [...new Set(CATALOGUE.map((m) => m.soldAs))].sort((a, b) => Number(a) - Number(b));

export const starOptions = () =>
  [...new Set(CATALOGUE.map((m) => m.stars))].sort((a, b) => b - a);

// Annual running cost from BEE published consumption, scaled by hours.
// Delhi tariff default matches your ac-engine city data.
export function runningCost(model, { hoursPerYear = 1600, tariff = 5.2 } = {}) {
  const kwh = model.annualKwh * (hoursPerYear / 1600);
  return { kwh: Math.round(kwh), cost: Math.round(kwh * tariff), hoursPerYear, tariff };
}